import { Injectable } from '@angular/core';
import { CanActivate, CanMatch, Route, Router, UrlSegment, UrlTree } from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanMatch, CanActivate {
  constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
  ) {}

  canMatch(_route: Route, _segments: UrlSegment[]): boolean | UrlTree {
    console.log('route', _route, 'seg', _segments);
    if (_route.path === 'suporte') {
      if (!this.auth.isAdmin) return false;
    }
    return this.check();
  }

  canActivate(): boolean | UrlTree {
    return this.check();
  }

  private check(): boolean | UrlTree {
    if (this.auth.isLoggedIn) return true;
    return this.router.parseUrl('/login');
  }
}
